import { render, staticRenderFns } from "./highlightable.vue?vue&type=template&id=75031c72&scoped=true&"
import script from "./highlightable.vue?vue&type=script&lang=ts&"
export * from "./highlightable.vue?vue&type=script&lang=ts&"
import style0 from "./highlightable.vue?vue&type=style&index=0&id=75031c72&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75031c72",
  null
  
)

export default component.exports